import { render, staticRenderFns } from "./GroupBySelector.vue?vue&type=template&id=54312d7a&scoped=true"
import script from "./GroupBySelector.vue?vue&type=script&lang=js"
export * from "./GroupBySelector.vue?vue&type=script&lang=js"
import style0 from "./GroupBySelector.vue?vue&type=style&index=0&id=54312d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54312d7a",
  null
  
)

export default component.exports